exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropzone {\n  border: 2px dashed #54cc96 !important;\n  border-radius: 20px;\n  min-height: 15rem;\n}\n.dropzone .dz-message {\n  margin: 3rem 0 !important;\n}\n.dropzone .dz-message .dz-button {\n  background: none;\n  color: inherit;\n  border: none;\n  padding: 0;\n  font: inherit;\n  cursor: pointer;\n  outline: inherit;\n}\n.dropzone .dz-preview .dz-error-message {\n  top: 153px !important;\n}\n.dropzone .dz-preview .dz-remove {\n  color: #ff5560;\n  font-weight: bold;\n}\n.dropzone .dropzone-message-wrapper {\n  color: #7a7a7a !important;\n}\n.dropzone .dropzone-start-message {\n  font-size: 54px !important;\n}", ""]);

// exports
